import { jsx as k } from "react/jsx-runtime";
import S from "../../ui-kit/theme-button.mjs";
import { BadRequest as b } from "@systemeio/util";
import { useLoadPaypalScript as B } from "./use-load-paypal-script.mjs";
import { useStore as D } from "../../store/index.mjs";
import { buyOffer as F } from "../../pages/checkout/api/index.mjs";
import { offerDefaultErrors as P } from "../../pages/checkout/constants/default-errors.mjs";
function E({
  isFetching: p,
  buttonTitle: s,
  buttonDisabled: u,
  setErrors: f,
  setIsFetching: t,
  preSubmit: m,
  handleBadRequest: w
}) {
  const { locale: d } = D(), { isScriptLoading: y } = B();
  return /* @__PURE__ */ k(
    S,
    {
      onClick: async (h) => {
        var r, e, a, i, n;
        h.preventDefault(), t(!0), f(P);
        try {
          const o = m();
          if (!o) return;
          (r = window.paypal) == null || r.checkout.initXO();
          const { redirect: c, approvalUrl: l } = await F(o, d);
          if (!l) {
            (e = window.paypal) == null || e.checkout.closeFlow(), c && window.location.assign(c);
            return;
          }
          (a = window.paypal) == null || a.checkout.startFlow(l);
        } catch (o) {
          if (o instanceof b)
            w(o), (i = window.paypal) == null || i.checkout.closeFlow();
          else
            throw (n = window.paypal) == null || n.checkout.closeFlow(), o;
        } finally {
          t(!1);
        }
      },
      isFetching: p,
      disabled: y || u,
      type: "submit",
      children: s
    }
  );
}
export {
  E as PaypalSoapPaymentButton
};
